import Checkout from "gifts/checkout"
import VueComponent from "../vue_component"

export default VueComponent(Checkout)
